import { matchPath } from "react-router-dom";

export const createPathMatcher = (pathname: string) => (path: string) =>
    Boolean(matchPath({ path, end: false }, pathname));

export const getConfigPathFlags = (pathname: string) => {
    const isPathMatch = createPathMatcher(pathname);

    return {
        isXPathMappingsPath: isPathMatch("/pushback/XpathMappings"),
        isConfigPushbackPath: isPathMatch("/configuration/ConfigPushback"),
        isConfigBundlingPath: isPathMatch("/configuration/ConfigBundling"),
    };
};
